// extracted by mini-css-extract-plugin
module.exports = {"bot-avatar-container":"bot-avatar-container__95ofwXyAXMp1","avatar":"avatar__14MedoYPsFO3"};